export default __webpack_public_path__ + "static/media/top-b-9-med.94415fe9.jpg";